// "Confirmar 426,000 kg?" — produto por quilo/litro com mais de 30 (pedido de
// 30/09/2026: 426 digitado no lugar de 0,426 cobrava 426 kg). O "Corrigir" vem
// com o foco: Enter sem pensar volta para o peso, não adiciona.
import { useRef } from "react";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../components/ui/dialog";

export default function DialogoPesoAlto({ peso, unidade, onConfirmar, onCorrigir }) {
  const corrigirRef = useRef(null);
  const texto = peso != null ? Number(peso).toFixed(3).replace(".", ",") : "";
  return (
    <Dialog open={peso != null} onOpenChange={(v) => { if (!v) onCorrigir(); }}>
      <DialogContent hideClose data-e2e="dialog-peso-alto" onOpenAutoFocus={(e) => { e.preventDefault(); corrigirRef.current?.focus(); }}
        className="sm:max-w-xs p-0 gap-0 overflow-hidden bg-zinc-900 border-0 rounded-2xl w-[85vw] sm:w-full">
        <div className="p-6 text-center">
          <div className="text-4xl mb-3">⚖️</div>
          <DialogHeader className="mb-6">
            <DialogTitle className="text-lg font-bold text-zinc-100 text-center">Confirmar {texto} {unidade}?</DialogTitle>
            <DialogDescription className="text-sm text-zinc-400 text-center">Mais de 30 {unidade}. Confira o peso antes de adicionar.</DialogDescription>
          </DialogHeader>
          <div className="flex gap-3">
            <button ref={corrigirRef} type="button" onClick={onCorrigir} data-e2e="peso-alto-corrigir"
              className="flex-1 h-12 rounded-full bg-zinc-700 hover:bg-zinc-600 text-zinc-100 font-bold text-sm transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-500/60">Corrigir</button>
            <button type="button" onClick={onConfirmar} data-e2e="peso-alto-confirmar"
              className="flex-1 h-12 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-bold text-sm transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-500/60">Confirmar</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
